module.exports = __webpack_public_path__ + "img/feature-illustration-2.003d7e3.svg";